// Developer/QA inspection flags. The source-graph trust layer (badges, the
// Verified/Probable/Suggested filter, the "Why this source?" modal) keeps
// RUNNING for every learner (filters, grouping) - recordAdapted feeds the session
// audit store only when this flag is on or in a dev build - and its vocabulary
// only RENDERS when this flag is on. Learners see sources as sources; inspectors
// see the machinery.
//
// Two ways in, both deliberate and undiscoverable (no UI affordance):
//   - URL:          ?debug=trust        (one-off look, works in prod for QA)
//   - localStorage: mm-debug-trust = 1  (sticky across reloads on one device)
//
// Read per call (never cached at module scope) so tests and the console can
// flip it without a reload dance.

export function isSourceDebug(): boolean {
  try {
    if (new URLSearchParams(window.location.search).get("debug") === "trust") return true;
  } catch {
    /* no window/location (or a malformed search string) -> fall through */
  }
  try {
    return window.localStorage.getItem("mm-debug-trust") === "1";
  } catch {
    return false; // storage blocked (private mode etc) -> never debug
  }
}
